export enum CallListenerType {
  All,
  First,
  Last,
}

export interface EmitOptions {
  callListeners: CallListenerType;
}
